const defaultOptions = {
    closeButton: true,
	closeHtml: '<span aria-label="Click to close."></span>',
    preventDuplicates: false,
    newestOnTop: true,
    positionClass: "toast-top-center",
    showDuration: 0,
    hideDuration: 0,
	target: 'main',
}
const persistentOptions = {
    ...defaultOptions,
    timeOut: 0,
    extendedTimeOut: 0,
}

const timeoutOptions = {
    ...defaultOptions,
    timeOut: 10000,
    extendedTimeOut: 10000,
    progressBar: true
}

export const toastrOptions = {
    ServerError: persistentOptions,
    Error: persistentOptions,
    Success: timeoutOptions,
    Info: timeoutOptions,
    Warning: persistentOptions,
};
